module.exports = __webpack_public_path__ + "assets/c93d28c9d04282161c40518eb15515c6.png";